'use client';

import * as React from 'react';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import GlobalStyles from '@mui/material/GlobalStyles';

import { useMediaQuery } from '@/hooks/v2/use-media-query';
import { useSettings } from '@/hooks/v2/use-settings';
import { useUser } from '@/hooks/v2/use-user';
import { Logo } from '@/components/core/v2/logo';

export interface MinimalLayoutProps {
  children?: React.ReactNode;
}

export function MinimalLayout({ children }: MinimalLayoutProps): React.JSX.Element {
  const { settings } = useSettings();
  const { user, account, isLoading } = useUser();
  const isMobile = useMediaQuery('down', 'lg');

  if (isLoading) {
    return (
      <Fade in={isLoading} timeout={1000}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <Logo />
        </Box>
      </Fade>
    );
  }

  return (
    <React.Fragment>
      <GlobalStyles
        styles={{
          body: {
            '--MainNav-height': '56px',
            '--MainNav-zIndex': 1000,
            '--MobileNav-width': '320px',
            '--MobileNav-zIndex': 1100,
          },
        }}
      />
      <Box
        sx={{
          bgcolor: 'var(--mui-palette-background-default)',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          minHeight: '100%',
        }}
      >
        <Box sx={{ display: 'flex', flex: '1 1 auto', flexDirection: 'column', pl: { lg: 'var(--SideNav-width)' } }}>
          <Box
            component="main"
            sx={{
              '--Content-margin': '0 auto',
              '--Content-maxWidth': 'var(--maxWidth-xl)',
              '--Content-paddingX': '24px',
              '--Content-paddingY': { xs: '24px', lg: '56px' },
              '--Content-padding': 'var(--Content-paddingY) var(--Content-paddingX)',
              '--Content-width': '100%',
              display: 'flex',
              flex: '1 1 auto',
              flexDirection: 'column',
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
}
